<form [formGroup]="form" autocomplete="off" class="form-horizontal m-1x mb-3x mt-3x">

  <div class="form-row mb-3x">
    <div class="form-check">
      <input
        class="form-check-input"
        formControlName="isKStUndGewStOrgangesellschaft"
        (change)="onKStCheckboxChange()"
        id="isKStUndGewStOrgangesellschaft{{index}}"
        type="checkbox"
        utilsCheckValidity
        utilsControlState
        utilsValidationMessage>
      <label class="form-check-label" for="isKStUndGewStOrgangesellschaft{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.KST_GEWST_ORGANGESELLSCHAFT' | translate }}
      </label>
    </div>
  </div>

  <div *ngIf="data.isKStUndGewStOrgangesellschaft" class="mb-5x">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="nameOrgantraegerKSt{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.NAME_ORGANTRAEGER' | translate }}
      </label>
      <div class="col-sm-8">
        <input class="form-control"
               formControlName="nameOrgantraegerKSt"
               id="nameOrgantraegerKSt{{index}}"
               type="text"
               utilsCheckValidity
               utilsControlState
               utilsValidationMessage/>
      </div>
    </div>
    <common-ui-steuernummer
      [(data)]="data.steuernummerKSt"
      [index]="index"
      [readonly]="readonly">
    </common-ui-steuernummer>
    <common-ui-wirtschafts-id
      [(data)]="data"
      [index]="index"
      [readonly]="readonly"
      fieldName="wirtschaftsIdNummerKSt">
    </common-ui-wirtschafts-id>
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="datumGewinnAbfVertrag{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.DATUM_GEWINNABFVERTRAG' | translate }}
      </label>
      <div class="col-sm-8">
        <date-picker
          id="datumGewinnAbfVertrag{{index}}"
          messagePath="datumGewinnAbfVertrag{{objectId}}"
          formControlName="datumGewinnAbfVertrag">
        </date-picker>
      </div>
    </div>
  </div>

  <div class="form-row mb-3x">
    <div class="form-check">
      <input
        class="form-check-input"
        formControlName="isUStOrgantraegerIdentisch"
        (change)="onUStIdentischCheckboxChange()"
        id="isUStOrgantraegerIdentisch{{index}}"
        type="checkbox"
        utilsCheckValidity
        utilsControlState
        utilsValidationMessage>
      <label class="form-check-label" for="isUStOrgantraegerIdentisch{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.UST_ORGANTRAEGER_IDENTISCH' | translate }}
      </label>
    </div>
  </div>

  <div class="form-row mb-3x">
    <div class="form-check">
      <input
        class="form-check-input"
        formControlName="isUmsatzsteuerOrgangesellschaft"
        (change)="onUStOrgangesellschaftCheckboxChange()"
        id="isUmsatzsteuerOrgangesellschaft{{index}}"
        type="checkbox"
        utilsCheckValidity
        utilsControlState
        utilsValidationMessage>
      <label class="form-check-label" for="isUmsatzsteuerOrgangesellschaft{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.UST_ORGANGESELLSCHAFT' | translate }}
      </label>
    </div>
  </div>

  <div *ngIf="showUStBereich()" class="mb-5x">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="nameOrgantraegerUSt{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.NAME_ORGANTRAEGER' | translate }}
      </label>
      <div class="col-sm-8">
        <input class="form-control"
               formControlName="nameOrgantraegerUSt"
               id="nameOrgantraegerUSt{{index}}"
               type="text"
               utilsCheckValidity
               utilsControlState
               utilsValidationMessage/>
      </div>
    </div>
    <common-ui-steuernummer
      [(data)]="data.steuernummerUSt"
      [index]="index"
      [readonly]="readonly">
    </common-ui-steuernummer>
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="ustIdentifikationsnummer{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.UST_IDENTIFIKATIONSNUMMER' | translate }}
      </label>
      <div class="col-sm-8">
        <input class="form-control"
               formControlName="ustIdentifikationsnummer"
               datevMessagePath="ustIdentifikationsnummer{{objectId}}"
               id="ustIdentifikationsnummer{{index}}"
               type="text"
               utilsCheckValidity
               utilsControlState
               utilsValidationMessage/>
      </div>
    </div>
    <common-ui-wirtschafts-id
      [(data)]="data"
      [index]="index"
      [readonly]="readonly"
      fieldName="wirtschaftsIdNummerUSt">
    </common-ui-wirtschafts-id>
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="beginnUStOrganschaft{{index}}">
        {{ 'FRAGEBOGEN_KAPG_AUS.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE_FORM.BEGINN_UST_ORGANSCHAFT' | translate }}
      </label>
      <div class="col-sm-8">
        <date-picker
          id="beginnUStOrganschaft{{index}}"
          messagePath="beginnUStOrganschaft{{objectId}}"
          formControlName="beginnUStOrganschaft">
        </date-picker>
      </div>
    </div>
  </div>

</form>

